<script setup lang="ts">
import { useGeneralStore } from '@/stores/general';

const generalStore = useGeneralStore();

interface Props {
  text: string;
  backgroundColor?: string /** @deprecated Use `background` instead */;
  textColor?: string;
  icon?: Array<string | number>;
  iconSize?: string;
  padding?: string;
  shadow?: boolean;
  isSave?: boolean;
  disabled?: boolean;
  rounded?: string;
  background?: string;
  typography?: string;
}

const props = withDefaults(defineProps<Props>(), {
  textColor: 'text-neutral-0',
  padding: 'px-10 py-6',
  shadow: false,
  isSave: false,
  disabled: false,
  rounded: 'lg',
  typography: 'text-3xl',
  iconSize: 'text-3xl',
});
</script>

<template>
  <div
    class="flex justify-center items-center text-base"
    :class="[
      {
        'shadow-xsm': props.shadow,
      },
      padding,
      `rounded-${props.rounded}`,
      props.background,
      textColor,
    ]"
    :style="[
      {
        height: '80px',
        backgroundColor: props.background,
        opacity: props.disabled ? 0.5 : 1,
      },
    ]"
  >
    <span v-if="icon">
      <fa-icon
        v-if="isSave && generalStore.isSaving"
        class="mr-3 fa-spin text-3xl"
        :icon="['fal', 'spinner']"
      />
      <fa-icon
        v-else
        :class="[iconSize, { 'mr-3': text.length }]"
        :icon="icon"
      />
    </span>
    <span :class="typography">{{ $t(text) }}</span>
  </div>
</template>
